<template>
    <div class="py-2 px-2 my-2 border border-gray-200 flex w-full hover:bg-gray-100">
        <div class="p-1 w-full flex justify-between items-center">
            <div>
                {{ template.name }} <span class="text-gray-500 text-sm hidden md:inline">({{ template.created_at }} | {{
                    template.amountTopics
                }} {{ $t("templates.topics") }} ) </span>
            </div>
            <div class="flex items-center">
                <button type="button"
                        @click="makeDefault()"
                        v-if="!template.default">
                    <HeartIcon class="h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                </button>

                <HeartIconFilled v-if="template.default" class="inline-block h-5 w-5 text-red-700" />

                <button type="button" @click="toCopyPage()">
                    <DuplicateIcon class="ml-4 h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                </button>

                <button type="button" @click="toEditPage()">
                    <PencilIcon class="ml-4 h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                </button>

                <button type="button" @click="toEditTopicsPage()">
                    <SearchIcon class="ml-4 h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                </button>

                <button type="button"
                        v-if="!template.default"
                        @click="toDeletePage()">
                    <TrashIcon class="h-5 ml-4 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import { DuplicateIcon, HeartIcon, PencilIcon, SearchIcon, TrashIcon } from "@heroicons/vue/outline";
import { HeartIcon as HeartIconFilled } from "@heroicons/vue/solid";

export default {
    props: ["template"],
    components: { Link, SearchIcon, HeartIcon, DuplicateIcon, PencilIcon, TrashIcon, HeartIconFilled },
    methods: {
        toCopyPage() {
            this.$inertia.visitInModal(this.route("advisors.templates.showCopy", this.template.uuid));
        },
        toEditTopicsPage() {
            this.$inertia.visit(this.route("advisors.templates.editTopics", this.template.uuid));
        },
        toEditPage() {
            this.$inertia.visitInModal(this.route("advisors.templates.edit", this.template.uuid));
        },
        toDeletePage() {
            this.$inertia.visitInModal(this.route("advisors.templates.delete", this.template.uuid));
        },
        makeDefault() {
            this.$inertia.put(this.route("advisors.templates.makeDefault", this.template.uuid), {}, {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: "actions.success",
                    text: "templates.markedDefault"
                })
            });
        }
    }
};
</script>

<style scoped></style>
